module.exports = __webpack_public_path__ + "img/morning.072e1fad.svg";